const EN = {
  //Sign
  langSign: {
    title: 'Login',
    employeeInput: 'Kit number *',
    passInput: 'Password *',
    buttonText: 'Login',
    incorrectData: 'Incorrect data',
    permissionDenied: 'You do not have permission to enter this section',
    incorrectInfo: 'Incorrect info',
    altLogo: 'Terramar Brands log',
  },
  langMenu: {
    atentions: 'Atentions',
    indicators: 'Indicadores',
    products: 'Web products',
    estafeta: 'Estafeta',
    dhl: 'DHL',
    dhlAvant: 'DHL Avant',
    paquete: 'Paquete express',
    rop: 'Form ROP',
    surveyadmin: 'Clima organizacional',
    survey: 'Encuesta clima organizacional',
    terrapedia: 'Terrapedia',
    logout: 'Logout',
    loadSheet: 'Loadsheet',
    digitalcatalog: 'Digital Catalog',
    uploadVideos: 'Upload videos',
  },
  langUploadVideos: {
    // Textos internos de la pantalla
    title: 'Upload videos',
    category: 'Category',
    selectCategory: 'Select a category',
    videoTitle: 'Title',
    link: 'Link',
    sequence: 'Sequence',
    save: 'Save',
    saving: 'Saving...',
    generatingSequence: 'Generating sequence...',
    automaticSequence: 'Generated automatically',
  },
  langAtentions: {
    sectionName: 'Atentions',
    wrongBrowser: 'Your browser does not allow this action',
    id: 'Invoice',
    statusCaptured: 'Captured',
    statusInProcess: 'In Process',
    statusReplica: 'Replica',
    statusClosed: 'Closed',
  },
};
export default EN;
